<template>
  <div style="width: fit-content; height: 100%;">
    <input
      v-if="type !== 'datetime'"
      :id="id"
      ref="dateinput"
      :class="`owal input ${nativeDate ? 'native' : 'basic'}`"
      :type="type"
      :value="value"
      @change="handleInput($event.target)"
      />
    <div v-else style="display: flex; flex-direction: row; width: fit-content;">
      <input
        :id="`${id}-date`"
        ref="dateinput"
        :class="`owal input ${nativeDate ? 'native' : 'basic'}`"
        type="date"
        :value="date"
        @change="handleInput($event.target)"
        />
      <input
        :id="`${id}-time`"
        ref="timeinput"
        :class="`owal input ${nativeDate ? 'native' : 'basic'}`"
        type="time"
        :value="time"
        @change="handleInput($event.target)"
        />
    </div>
  </div>
</template>

<script>
import * as nativeInputTag from '@/libraries/util/nativeInputCheck'
import moment from 'moment'

export default {
  name: 'OwalDateTimeInput',
  props: ['changeFunction', 'value', 'type', 'id'],
  data: function () {
    return {
      timeout: undefined,
      timestamp: undefined,
      datetimeFormat: {
        time: 'HH:mm:ss',
        date: 'YYYY-MM-DD',
      },
    }
  },
  computed: {
    nativeTime () {
      const supports = nativeInputTag.supportsTime()
      // console.debug(`Supports time: ${supports}`)
      return supports
    },
    nativeDate () {
      const supports = nativeInputTag.supportsDate()
      // console.debug(`Supports date: ${supports}`)
      return supports
    },
    date () {
      const timestamp = this.value ? moment.utc(this.value) : moment.utc()
      const dateString = timestamp.local().format(this.datetimeFormat.date)
      return dateString
    },
    time () {
      const timestamp = this.value ? moment.utc(this.value) : moment.utc()
      const timeString = timestamp.local().format(this.datetimeFormat.time)
      return timeString
    },
  },
  methods: {
    handleInput: function (target) {
      clearTimeout(this.timeout)
      const newTime = this.type === 'datetime' ? {
        id: target.id.replace(/-\w+/, ''),
        value: this.computeNewDatetime(target).format(),
      } : target
      this.timeout = setTimeout(function () {
        this.changeFunction(newTime)
      }.bind(this), 1000)
    },
    computeNewDatetime: function (target) {
      /**
       * Note: this functionality should be split out since it's also being used in OwalFilterPanel.vue
       * Two options: A) refactor function to accept start and end targets B) new component with a date and time picker + function
       */
      let timestamp
      /**
       * incoming value is local time (i.e. moment() interprets as local, moment.utc() interprets as utc)
       * https://stackoverflow.com/questions/50608132/difference-between-moment-utcdate-and-momentdate-utc
       */
      const incomingDatetime = moment(target.value, this.datetimeFormat[target.type])
      const localcurrentDatetime = this.value ? moment.utc(this.value).local() : moment()

      // convert incoming date to utc and use string template to update store
      if (target.type === 'date' && incomingDatetime.isValid()) {
        timestamp = moment(`${incomingDatetime.format(this.datetimeFormat.date)} ${localcurrentDatetime.format(this.datetimeFormat.time)}`, `${this.datetimeFormat.date} ${this.datetimeFormat.time}`)
      } else if (target.type === 'time' && incomingDatetime.isValid()) {
        timestamp = moment(`${localcurrentDatetime.format(this.datetimeFormat.date)} ${incomingDatetime.format(this.datetimeFormat.time)}`, `${this.datetimeFormat.date} ${this.datetimeFormat.time}`)
      } else {
        console.debug('Unknown date or time input')
      }
      return timestamp
    },
  },
}
</script>

<style scoped>
  .owal.input {
    background: #F0F0F0;
    color: #475669;
    border: 1px solid #E0E0E0;
    border-radius: 5px;
    display: flex;
    font-family: 'Avenir-Medium';
    font-weight: bold;
    margin: 0 0.25rem;
    letter-spacing: 0;
    padding: 0.5rem 1rem;
    text-align: center;
    z-index: 1;
    transition: opacity 200ms ease, transform 200ms ease;
  }

  .owal.input.basic {
    width: 9rem;
  }

  .owal.input.native {
    display: flex;
    justify-content: center;
    overflow: visible;
    transition: width 200ms ease;
    box-sizing: border-box;
    cursor: pointer;
  }

  .owal.input.native {
    width: 13.5rem;
  }

  .owal.input.native:hover {
    width: 14rem;
    transform: scale(1.05);
    opacity: 0.8;
  }
</style>
